module.exports = __webpack_public_path__ + "img/banner.ba6044de.png";